module.exports = __webpack_public_path__ + "img/logo.1662a086.png";